// extracted by mini-css-extract-plugin
export default {"previewImage":"FilePreview_previewImage__dTHTi","documentIcon":"FilePreview_documentIcon__UbSYh"};